import {
  useEntitySchema,
  useRouteAndQueryParams,
} from '@april9au/stack9-react';
import * as ui from '@april9au/stack9-ui';

import { AppRoutes } from '../../constants/appRoutes';
import { entityNames } from '../../constants/entities';
import { EDetailsQueryNames } from '../../constants/queryNames';
import PartnerForm from './PartnerForm';
import PartnerUser from './PartnerUser';

const S9CustomEntityFormPage = ui.S9CustomEntityFormPage.default;

const Index = () => {
  const { schema } = useEntitySchema(entityNames.PARTNER);

  const {
    routeParams: { id = '' },
  } = useRouteAndQueryParams();

  return (
    <S9CustomEntityFormPage
      entityKey={entityNames.PARTNER}
      screenQueryName={EDetailsQueryNames.GetPartnerDetails}
      entityId={+id}
      title={data => `Partner #${data?.id}`}
      cancelLink={AppRoutes.PartnerList}
    >
      <PartnerForm schema={schema} />
      <PartnerUser id={+id} />
    </S9CustomEntityFormPage>
  );
};
export default Index;
